export function buildProjectWorkUiContext(delivery, sprints = [], completed = false) {
    return {
        selected_delivery: delivery?.id ? {
            id: Number(delivery.id),
            name: delivery.nome || null,
            status: delivery.status || null,
            coordinator_user_id: delivery.coordenador_id || null,
            product_owner_user_id: delivery.po_id || null,
            completed: Boolean(completed),
        } : null,
        visible_sprints: (Array.isArray(sprints) ? sprints : []).map((sprint) => ({
            id: Number(sprint.id),
            name: sprint.nome || null,
            is_backlog: sprint.nome === 'Backlogs',
            is_open: sprint.nome !== 'Backlogs' && !sprint.dtTermino,
            start_date: sprint.dtInicio || null,
            end_date: sprint.dtTermino || null,
            task_count: Array.isArray(sprint.backlogs) ? sprint.backlogs.length : 0,
        })),
    }
}
